import React from "react";
import { css } from "@emotion/core";
import { font, color, mediaQuery, smartPhone } from "../constants/styles";
const dayjs = require("dayjs");

const wrapper = css`
  width: 90%;
  margin: 0 auto;
`;

const titleContainer = css`
  width: 90%;
  margin: 0 auto;
  background: ${color.whiteGray};
  line-height: 2.5;
  border-left: 2px solid ${color.pink};
  ${mediaQuery[smartPhone]} {
    line-height: 1.5;
  }
`;

const dayTime = css`
  padding-left: 16px;
  font-size: ${font.textSize};
  ${mediaQuery[smartPhone]} {
    font-size: ${font.miniTextSize};
  }
`;

const title = css`
  padding-left: 16px;
  font-size: ${font.subtitleSize};
  ${mediaQuery[smartPhone]} {
    font-size: ${font.textSize};
  }
`;

const imageWrapper = css`
  width: 80%;
  margin: 0 auto;
  padding: 24px 0;
`;

const text = css`
  line-height: 1.5;
  font-size: ${font.textSize};
  padding: 8px 0 24px 0;
`;

const imageContainer = css`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  grid-row: auto auto;
  grid-column-gap: 20px;
  grid-row-gap: 20px;
  padding: 8px 0 24px 0;
  ${mediaQuery[smartPhone]} {
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  }
`;

const displayNone = css`
  display: none;
`;

const image = css`
  max-width: 320px;
  ${mediaQuery[smartPhone]} {
    width: 240px;
  }
`;

export const NewsCard = (data) => {
  const daytime = 0;
  const date = dayjs(data.props[daytime]).format("YYYY/MM/DD");
  const newsTitle = 1;
  const newsText = 2;
  const isTextNull = data.props[newsText] === null;
  const newsImage1 = 3;
  const newsImage2 = 4;
  const newsImage3 = 5;
  const newsImage4 = 6;
  const isImageNull1 = data.props[newsImage1] === null;
  const isImageNull2 = data.props[newsImage2] === null;
  const isImageNull3 = data.props[newsImage3] === null;
  const isImageNull4 = data.props[newsImage4] === null;
  const isImageNull =
    isImageNull1 && isImageNull2 && isImageNull3 && isImageNull4;

  return (
    <div css={wrapper}>
      <div css={titleContainer}>
        <p css={dayTime}>{date}</p>
        <h2 css={title}>{data.props[newsTitle]}</h2>
      </div>
      <div css={imageWrapper}>
        <div
          css={isTextNull ? displayNone : text}
          dangerouslySetInnerHTML={{ __html: data.props[newsText] }}
        ></div>
        <div css={isImageNull ? displayNone : imageContainer}>
          <img
            src={isImageNull1 ? null : data.props[newsImage1].url}
            alt="投稿画像1"
            css={isImageNull1 ? displayNone : image}
          />
          <img
            src={isImageNull2 ? null : data.props[newsImage2].url}
            alt="投稿画像2"
            css={isImageNull2 ? displayNone : image}
          />
          <img
            src={isImageNull3 ? null : data.props[newsImage3].url}
            alt="投稿画像3"
            css={isImageNull3 ? displayNone : image}
          />
          <img
            src={isImageNull4 ? null : data.props[newsImage4].url}
            alt="投稿画像4"
            css={isImageNull4 ? displayNone : image}
          />
        </div>
      </div>
    </div>
  );
};
